
import SearchInput from '../../../components/base/SearchInput';

interface HeroSectionProps {
  onSearch: (query: string) => void;
  onAgencyFilter: (agency: string) => void;
}

export default function HeroSection({ onSearch, onAgencyFilter }: HeroSectionProps) {
  const agencies = [
    { name: 'All Agencies', value: '', color: 'bg-slate-700 hover:bg-slate-600' },
    { name: 'Fannie Mae', value: 'Fannie Mae', color: 'bg-emerald-600 hover:bg-emerald-500' },
    { name: 'Freddie Mac', value: 'Freddie Mac', color: 'bg-violet-600 hover:bg-violet-500' },
    { name: 'HUD/FHA', value: 'HUD', color: 'bg-amber-600 hover:bg-amber-500' },
    { name: 'VA', value: 'VA', color: 'bg-rose-600 hover:bg-rose-500' }
  ];

  return (
    <section 
      className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 py-24"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/2ebda814e2d0d80c42738e969206cb92.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-slate-900/70"></div>
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          All Loan Guidelines in One Place
        </h1>
        <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed">
          Search and compare guidelines from Fannie Mae, Freddie Mac, HUD, and VA. 
          Find the information you need quickly and efficiently.
        </p>
        
        <div className="max-w-2xl mx-auto mb-10">
          <SearchInput 
            onSearch={onSearch}
            placeholder="Search guidelines, requirements, or topics..."
            className="w-full"
          />
        </div>

        {/* Agency Filter Buttons */}
        <div className="mb-10">
          <h3 className="text-lg font-semibold text-slate-200 mb-6">Filter by Agency</h3>
          <div className="flex flex-wrap justify-center gap-4">
            {agencies.map((agency) => (
              <button
                key={agency.value}
                onClick={() => onAgencyFilter(agency.value)}
                className={`px-8 py-4 ${agency.color} text-white rounded-xl font-semibold transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-black/20 whitespace-nowrap cursor-pointer border border-white/10`}
              >
                {agency.name}
              </button>
            ))}
          </div>
        </div>
        
        <div className="flex flex-wrap justify-center gap-4 text-sm">
          <span className="px-4 py-2 bg-white/10 text-slate-300 rounded-full border border-white/20 backdrop-blur-sm">Popular: DTI Ratio</span>
          <span className="px-4 py-2 bg-white/10 text-slate-300 rounded-full border border-white/20 backdrop-blur-sm">Credit Score Requirements</span>
          <span className="px-4 py-2 bg-white/10 text-slate-300 rounded-full border border-white/20 backdrop-blur-sm">FHA Guidelines</span>
          <span className="px-4 py-2 bg-white/10 text-slate-300 rounded-full border border-white/20 backdrop-blur-sm">VA Eligibility</span>
        </div>
      </div>
    </section>
  );
}
